export const authFetch = async (url, options = {}) => {
  // Configurar headers por defecto, incluyendo Authorization si hay token
  const headers = new Headers(options.headers || {})

  const userString = sessionStorage.getItem('_user')
  if (userString) {
    try {
      const user = JSON.parse(userString)
      if (user.token && !headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${user.token}`)
      }
    } catch (e) {
      console.error('Error parsing _user from sessionStorage', e)
    }
  }

  const enhancedOptions = {
    cache: 'no-store',
    ...options,
    headers
  }

  try {
    const response = await fetch(url, enhancedOptions)

    // Si la respuesta no es ok, verificamos causas comunes de error de autenticación/autorización
    if (!response.ok) {
      if (response.status === 403) {
        // Podría ser ACCOUNT_DEACTIVATED
        try {
          // Clonamos la respuesta para poder leer el JSON sin consumir el stream de la original
          const clonedResponse = response.clone()
          const errorData = await clonedResponse.json()

          if (errorData.error === 'ACCOUNT_DEACTIVATED') {
            // Limpiar la sesión
            sessionStorage.removeItem('_user')
            // Dejar constancia de que la sesión terminó por cuenta desactivada
            sessionStorage.setItem('_retinar_session_notice', 'deactivated')
            // Redirigir al login
            window.location.href = '/login'
            // Retornar la respuesta original por si el hook que llama quiere manejarla
            return response
          }
        } catch (e) {
          // Si no se puede parsear como JSON, ignorar y retornar response normal
          console.error('Error parsing 403 response json:', e)
        }
      } else if (response.status === 401) {
        // Manejar 401 (sesión expirada u otro error de autenticación)
        // El comportamiento actual para 401 parece ser manejado centralmente o por componente
        // pero podemos mejorar esto limpiando la sesión si es necesario
        // sessionStorage.removeItem('_user')
        // En algunos casos ya existe un modal que reacciona a los interceptores.
      }
    }

    return response
  } catch (error) {
    // Errores de red
    throw error
  }
}
